/**
 * ── App brand font — SINGLE SOURCE OF TRUTH (per app) ─────────────────────────
 *
 * Bible Strong is an OFFLINE BIBLE READER: its identity is quiet, reverent,
 * long-form reading. The brand typeface is **EB Garamond** — a classic reading
 * serif that carries the erudite/scriptural tone and stays legible over long
 * study sessions. The whole app body reads in EB Garamond.
 *
 * This is the ONE place where THIS app declares "my default typeface is X". The
 * brand font is bundled and self-contained (see `src/styles/brand-font.css` +
 * the `--font-brand*` tokens in `src/styles/global.css`); it is ALWAYS present
 * and never depends on the font catalog/registry/CDN. It is also the target of
 * the "Reset to default" control.
 *
 * The catalog/custom fonts are a purely ADDITIVE layer on top: a user MAY switch
 * to one, but that is never required for the app to have its typeface.
 *
 * TO ADAPT PER APP (propagation): change `family` to this app's brand family and
 * keep it in sync with the bundled @font-face + `--font-brand*` CSS tokens.
 */
export const BRAND_FONT = {
  /**
   * CSS family name of the bundled brand typeface. MUST match the `@font-face`
   * `font-family` in `styles/brand-font.css` and the `--font-brand*` tokens.
   */
  // eslint-disable-next-line lingui/no-unlocalized-strings -- font family name (proper noun), never translated
  family: "EB Garamond",
  /** Human-readable label shown next to the "Reset to default" control. */
  // eslint-disable-next-line lingui/no-unlocalized-strings -- brand typeface name (proper noun), never translated
  label: "EB Garamond",
} as const;

export type BrandFont = typeof BRAND_FONT;
